export const RAL_CLASSIC_COLORS = Object.freeze({
  '1000':['#CDBA88','Grünbeige'],
  '1001':['#D0B084','Beige'],
  '1002':['#D2AA6D','Sandgelb'],
  '1003':['#F9A900','Signalgelb'],
  '1004':['#E49E00','Goldgelb'],
  '1005':['#CB8F00','Honiggelb'],
  '1006':['#E19000','Maisgelb'],
  '1007':['#E88C00','Narzissengelb'],
  '1011':['#AF8050','Braunbeige'],
  '1012':['#DDAF28','Zitronengelb'],
  '1013':['#E3D9C7','Perlweiß'],
  '1014':['#DDC49B','Elfenbein'],
  '1015':['#E6D2B5','Hellelfenbein'],
  '1016':['#F1DD39','Schwefelgelb'],
  '1017':['#F6A951','Safrangelb'],
  '1018':['#FACA31','Zinkgelb'],
  '1019':['#A48F7A','Graubeige'],
  '1020':['#A08F65','Olivgelb'],
  '1021':['#F6B600','Rapsgelb'],
  '1023':['#F7B500','Verkehrsgelb'],
  '1024':['#BA8F4C','Ockergelb'],
  '1026':['#FFFF00','Leuchtgelb'],
  '1027':['#A77F0F','Currygelb'],
  '1028':['#FF9C00','Melonengelb'],
  '1032':['#E2A300','Ginstergelb'],
  '1033':['#F99A1D','Dahliengelb'],
  '1034':['#EB9C52','Pastellgelb'],
  '1035':['#8F8370','Perlbeige'],
  '1036':['#806440','Perlgold'],
  '1037':['#F09200','Sonnengelb'],
  '2000':['#DA6E00','Gelborange'],
  '2001':['#BA481C','Rotorange'],
  '2002':['#BF3922','Blutorange'],
  '2003':['#F67829','Pastellorange'],
  '2004':['#E25304','Reinorange'],
  '2005':['#FF4D08','Leuchtorange'],
  '2007':['#FFB200','Leuchthellorange'],
  '2008':['#EC6B22','Hellrotorange'],
  '2009':['#DE5308','Verkehrsorange'],
  '2010':['#D05D29','Signalorange'],
  '2011':['#E26E0F','Tieforange'],
  '2012':['#D5654E','Lachsorange'],
  '2013':['#923E25','Perlorange'],
  '2017':['#FC5500','RAL orange'],
  '3000':['#A72920','Feuerrot'],
  '3001':['#9B2423','Signalrot'],
  '3002':['#9B2321','Karminrot'],
  '3003':['#861A22','Rubinrot'],
  '3004':['#6B1C23','Purpurrot'],
  '3005':['#59191F','Weinrot'],
  '3007':['#3E2022','Schwarzrot'],
  '3009':['#6D342D','Oxidrot'],
  '3011':['#782423','Braunrot'],
  '3012':['#C5856D','Beigerot'],
  '3013':['#972E25','Tomatenrot'],
  '3014':['#CB7375','Altrosa'],
  '3015':['#D8A0A6','Hellrosa'],
  '3016':['#A63D30','Korallenrot'],
  '3017':['#CA555D','Rosé'],
  '3018':['#C63F4A','Erdbeerrot'],
  '3020':['#BB1F11','Verkehrsrot'],
  '3022':['#CF6955','Lachsrot'],
  '3024':['#FF2D21','Leuchtrot'],
  '3026':['#FF2A1C','Leuchthellrot'],
  '3027':['#AB273C','Himbeerrot'],
  '3028':['#CC2C24','Reinrot'],
  '3031':['#A63437','Orientrot'],
  '3032':['#701D24','Perlrubinrot'],
  '3033':['#A53A2E','Perlrosa'],
  '4001':['#816183','Rotlila'],
  '4002':['#8D3C4B','Rotviolett'],
  '4003':['#C4618C','Erikaviolett'],
  '4004':['#651E38','Bordeauxviolett'],
  '4005':['#76689A','Blaulila'],
  '4006':['#903373','Verkehrspurpur'],
  '4007':['#47243C','Purpurviolett'],
  '4008':['#844C82','Signalviolett'],
  '4009':['#9D8692','Pastellviolett'],
  '4010':['#BB4077','Telemagenta'],
  '4011':['#6E6387','Perlviolett'],
  '4012':['#6A6B7F','Perlbrombeer'],
  '5000':['#304F6E','Violettblau'],
  '5001':['#0E4C64','Grünblau'],
  '5002':['#00387A','Ultramarinblau'],
  '5003':['#1F3855','Saphirblau'],
  '5004':['#191E28','Schwarzblau'],
  '5005':['#005387','Signalblau'],
  '5007':['#376B8C','Brillantblau'],
  '5008':['#2B3A44','Graublau'],
  '5009':['#215F78','Azurblau'],
  '5010':['#004F7C','Enzianblau'],
  '5011':['#1A2B3C','Stahlblau'],
  '5012':['#0089B6','Lichtblau'],
  '5013':['#193153','Kobaltblau'],
  '5014':['#637D96','Taubenblau'],
  '5015':['#007CAF','Himmelblau'],
  '5017':['#005B8C','Verkehrsblau'],
  '5018':['#048B8C','Türkisblau'],
  '5019':['#005E83','Capriblau'],
  '5020':['#00414B','Ozeanblau'],
  '5021':['#007577','Wasserblau'],
  '5022':['#222D5A','Nachtblau'],
  '5023':['#41698C','Fernblau'],
  '5024':['#6093AC','Pastellblau'],
  '5025':['#20697C','Perlenzian'],
  '5026':['#0F3052','Perlnachtblau'],
  '6000':['#3C7460','Patinagrün'],
  '6001':['#366735','Smaragdgrün'],
  '6002':['#325928','Laubgrün'],
  '6003':['#50533C','Olivgrün'],
  '6004':['#024442','Blaugrün'],
  '6005':['#114232','Moosgrün'],
  '6006':['#3C392E','Grauoliv'],
  '6007':['#2C3222','Flaschengrün'],
  '6008':['#36342A','Braungrün'],
  '6009':['#27352A','Tannengrün'],
  '6010':['#4D6F39','Grasgrün'],
  '6011':['#6B7C59','Resedagrün'],
  '6012':['#2F3D3A','Schwarzgrün'],
  '6013':['#7C765A','Schilfgrün'],
  '6014':['#474135','Gelboliv'],
  '6015':['#3D3D36','Schwarzoliv'],
  '6016':['#00694C','Türkisgrün'],
  '6017':['#587F40','Maigrün'],
  '6018':['#60993B','Gelbgrün'],
  '6019':['#B9CEAC','Weißgrün'],
  '6020':['#37422F','Chromoxidgrün'],
  '6021':['#8A9977','Blaßgrün'],
  '6022':['#3A3327','Braunoliv'],
  '6024':['#008351','Verkehrsgrün'],
  '6025':['#5E6E3B','Farngrün'],
  '6026':['#005F4E','Opalgrün'],
  '6027':['#7EBAB5','Lichtgrün'],
  '6028':['#315442','Kieferngrün'],
  '6029':['#006F3D','Minzgrün'],
  '6032':['#237F52','Signalgrün'],
  '6033':['#45877F','Minttürkis'],
  '6034':['#7AADAC','Pastelltürkis'],
  '6035':['#194D25','Perlgrün'],
  '6036':['#04574B','Perlopalgrün'],
  '6037':['#008B29','Reingrün'],
  '6038':['#00B51B','Leuchtgrün'],
  '6039':['#B3C43E','Fasergrün'],
  '7000':['#7A888E','Fehgrau'],
  '7001':['#8C979C','Silbergrau'],
  '7002':['#817863','Olivgrau'],
  '7003':['#797669','Moosgrau'],
  '7004':['#9A9B9B','Signalgrau'],
  '7005':['#6B6E6B','Mausgrau'],
  '7006':['#766A5E','Beigegrau'],
  '7008':['#745F3D','Khakigrau'],
  '7009':['#5D6058','Grüngrau'],
  '7010':['#585C56','Zeltgrau'],
  '7011':['#52595D','Eisengrau'],
  '7012':['#575D5E','Basaltgrau'],
  '7013':['#575044','Braungrau'],
  '7015':['#4F5358','Schiefergrau'],
  '7016':['#383E42','Anthrazitgrau'],
  '7021':['#2F3234','Schwarzgrau'],
  '7022':['#4C4A44','Umbragrau'],
  '7023':['#808076','Betongrau'],
  '7024':['#45494E','Graphitgrau'],
  '7026':['#374345','Granitgrau'],
  '7030':['#928E85','Steingrau'],
  '7031':['#5B686D','Blaugrau'],
  '7032':['#B5B0A1','Kieselgrau'],
  '7033':['#7F8274','Zementgrau'],
  '7034':['#92886F','Gelbgrau'],
  '7035':['#C5C7C4','Lichtgrau'],
  '7036':['#979392','Platingrau'],
  '7037':['#7A7B7A','Staubgrau'],
  '7038':['#B0B0A9','Achatgrau'],
  '7039':['#6B665E','Quarzgrau'],
  '7040':['#989EA1','Fenstergrau'],
  '7042':['#8E9291','Verkehrsgrau A'],
  '7043':['#4F5250','Verkehrsgrau B'],
  '7044':['#B7B3A8','Seidengrau'],
  '7045':['#8D9295','Telegrau 1'],
  '7046':['#7E868A','Telegrau 2'],
  '7047':['#C8C8C7','Telegrau 4'],
  '7048':['#817B73','Perlmausgrau'],
  '8000':['#89693F','Grünbraun'],
  '8001':['#9D622B','Ockerbraun'],
  '8002':['#794D3E','Signalbraun'],
  '8003':['#7E4B27','Lehmbraun'],
  '8004':['#8D4931','Kupferbraun'],
  '8007':['#70462B','Rehbraun'],
  '8008':['#724A25','Olivbraun'],
  '8011':['#5A3827','Nußbraun'],
  '8012':['#66332B','Rotbraun'],
  '8014':['#4A3526','Sepiabraun'],
  '8015':['#5E2F26','Kastanienbraun'],
  '8016':['#4C2B20','Mahagonibraun'],
  '8017':['#442F29','Schokoladenbraun'],
  '8019':['#3D3635','Graubraun'],
  '8022':['#1A1719','Schwarzbraun'],
  '8023':['#A45729','Orangebraun'],
  '8024':['#795038','Beigebraun'],
  '8025':['#755847','Blaßbraun'],
  '8028':['#513A2A','Terrabraun'],
  '8029':['#7F4031','Perlkupfer'],
  '9001':['#E9E0D2','Cremeweiß'],
  '9002':['#D6D5CB','Grauweiß'],
  '9003':['#ECECE7','Signalweiß'],
  '9004':['#2B2B2C','Signalschwarz'],
  '9005':['#0E0E10','Tiefschwarz'],
  '9006':['#A1A1A0','Weißaluminium'],
  '9007':['#868581','Graualuminium'],
  '9010':['#F1EDE1','Reinweiß'],
  '9011':['#27292B','Graphitschwarz'],
  '9012':['#F8F2E1','Reinraumweiß'],
  '9016':['#F1F1EA','Verkehrsweiß'],
  '9017':['#29292A','Verkehrsschwarz'],
  '9018':['#C8CBC4','Papyrusweiß'],
  '9022':['#858583','Perlhellgrau'],
  '9023':['#787B7A','Perldunkelgrau'],
});

export const RAL_DB = RAL_CLASSIC_COLORS;
